import React from "react";

const Highlight = ({data}) => {
  return (
    <section className="container-fluid bg-[#FEF2E7]"  style={{ background: data.bottom_text_bg }}>
      <div className="container">
        <p className="text-[#000000] md:text-[1.59vw] py-[1.2vw] text-center font-redhatMedium">
          {data.data.bottom_text}
        </p>
      </div>
    </section>
  );
};

export default Highlight;
